<template>
  <div class="head">
    <div class="width1746">
      <b-navbar toggleable="lg">
        <a href="/"><img src="@/assets/images/logo.png" alt="" /></a>
        <b-navbar-toggle
          target="nav-collapse"
          @click="toggle"
        ></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="navList">
            <b-nav-item
              v-for="(item, index) in navList"
              :key="index"
              :href="item.href"
              :class="current == item.name ? 'active' : ''"
              >{{ item.text }}</b-nav-item
            >
          </b-navbar-nav>
          <b-navbar-nav class="navInfo" v-if="username">
            <!-- 跳转至portal后台 -->
            <a href="#" class="username" @click="toPortal">{{ username }}</a>
          </b-navbar-nav>
          <b-navbar-nav class="navInfo" v-else>
            <button @click="isLogin">登录</button>
            <button @click="isRegister">注册</button>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      toggleStatus: false,
      navList: [
        { id: 0, name: "index", text: "首页", href: "/" },
        { id: 1, name: "proxyhttp", text: "HTTP隧道代理", href: "/proxyhttp" },
        {
          id: 2,
          name: "proxysmall",
          text: "家庭住宅短效代理",
          href: "/proxysmall",
        },
        {
          id: 3,
          name: "proxylong",
          text: "家宽住宅长效代理",
          href: "/proxylong",
        },
        { id: 4, name: "proxyip", text: "静态IP代理", href: "/proxyip" },
      ],
      username: '',
    }
  },
  computed: {
    current () {
      return this.$route.name
    },
  },
  mounted() {
    // console.dir('username:' + username)
    this.username = Cookies.get('username')
  },
  methods: {
    isLogin () {
      // this.$emit("login")
      // 跳转至portal登录页
      window.location.href = process.env.VUE_APP_PORTAL_URL + 'login'
    },
    isRegister () {
      // this.$emit("register")
      // 跳转至portal注册页
      window.location.href = process.env.VUE_APP_PORTAL_URL + 'register'
    },
    toPortal() {
      window.location.href = process.env.VUE_APP_PORTAL_URL
    },
    toggle () {
      this.toggleStatus = !this.toggleStatus
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  background: linear-gradient(to right, #51caed, #3c8bdc, #1a21c0);
  padding: 15px 0;
  .navbar {
    padding: 0;
  }
  .navbar-light .navbar-toggler {
    background: #fff;
  }
  .navbar-light .navbar-nav .nav-link {
    color: #fff;
    padding: 0;
    line-height: 40px;
  }
  .navbar-light .navbar-nav .active > .nav-link {
    color: #fff;
    border-bottom: 1px solid #fff;
  }
  button {
    border: none;
    margin-left: 10px;
    padding: 4px 20px;
    border-radius: 6px;
    &:nth-of-type(1) {
      background: none;
      color: #fff;
    }
    &:nth-of-type(2) {
      color: #004cba;
    }
  }
  .navList {
    width: 76%;
    justify-content: space-around;
    margin-left: 8%;
  }
  .navInfo {
    width: 20%;
    justify-content: flex-end;

    .username {
      color: white;
    }
  }
}
.navbar-collapse.show .navInfo {
  margin-left: 4%;
  padding: 1% 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
@media (max-width: 1024px) {
  .head button {
    padding: 4px 10px;
  }
}
</style>
